import { useAppContext } from '@/operator/context/AppContext';

export const useHandleUserSessionData = () => {
    const {
        givenName,
        surName,
        setOrgList,
        setGivenName,
        setSurname,
        setPreferredName,
        setPronouns,
        setAvatar,
    } = useAppContext();

    const checkSessionDataIntegrity = () => {
        if (givenName.trim().length > 0 && surName.trim().length > 0) {
            return true;
        } else {
            return false;
        }
    };

    const removeSessionData = () => {
        setOrgList([]);
        setGivenName('');
        setSurname('');
        setPreferredName('');
        setPronouns('');
        setAvatar('');
    };

    return {
        removeSessionData,
        checkSessionDataIntegrity,
    };
};
